export default __webpack_public_path__ + "static/media/Zeballos.7ab63819.jpg";